/* All @import must come first (CSS spec). Design system: Cairo, Lora, Open Sans. */
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&family=Lora:ital,wght@0,400&family=Open+Sans:wght@400&display=swap');
@import 'tailwindcss';
@import 'uniwind';
@import './src/theme/theme-colors.generated.css';

/* Typography and other design tokens */
@theme {
  /* Font family – Cairo primary, Roboto fallback, system sans-serif */
  --font-family-base:
    'Cairo_400Regular', 'Cairo', 'Roboto', -apple-system, BlinkMacSystemFont,
    'Segoe UI', sans-serif;
  --font-family-light: 'Cairo_300Light', 'Cairo', 'Roboto', sans-serif;
  --font-family-medium: 'Cairo_500Medium', 'Cairo', 'Roboto', sans-serif;
  /* Design system: Headings + Labels = Cairo; Quotes = Lora; Body = Open Sans */
  --font-family-headline: 'Cairo_700Bold', 'Cairo', sans-serif;
  --font-family-label: 'Cairo_600SemiBold', 'Cairo', sans-serif;
  --font-family-quote: 'Lora_400Regular', 'Lora', serif;
  --font-family-body: 'OpenSans_400Regular', 'Open Sans', sans-serif;
  --font-family-lora: 'Lora_400Regular', 'Lora', serif;
  --font-family-open-sans: 'OpenSans_400Regular', 'Open Sans', sans-serif;

  /* Design system – Ag Headings (Cairo Bold): 24/26, 20/22, 18/20 */
  --text-headline-1: 1.5rem; /* 24px */
  --text-headline-1--font-weight: 700;
  --text-headline-2: 1.25rem; /* 20px */
  --text-headline-2--font-weight: 700;
  --text-headline-3: 1.125rem; /* 18px */
  --text-headline-3--font-weight: 700;

  /* Design system – Ag Quotes (Lora Regular): 24, 20, 18 */
  --text-quote-1: 1.5rem; /* 24px */
  --text-quote-2: 1.25rem; /* 20px */
  --text-quote-3: 1.125rem; /* 18px */

  /* Design system – Ag Body (Open Sans): 18/20, 16/18, 14/16, 12/Auto */
  --text-body-1: 1.125rem; /* 18px */
  --text-body-2: 1rem; /* 16px */
  --text-body-3: 0.875rem; /* 14px */
  --text-body-4: 0.75rem; /* 12px */

  /* Design system – Ag Label (Cairo Semibold): 16/18, 14/16, 12/14 */
  --text-label-1: 1rem; /* 16px */
  --text-label-1--font-weight: 600;
  --text-label-2: 0.875rem; /* 14px */
  --text-label-2--font-weight: 600;
  --text-label-3: 0.75rem; /* 12px */
  --text-label-3--font-weight: 600;

  /* Typography scales aligned with web (Material-UI) – legacy */
  --text-h1: 6rem; /* 96px – largest headings */
  --text-h1--letter-spacing: -0.015em;
  --text-h1--font-weight: 100;

  --text-h2: 3.175rem; /* 50.8px – major headings */
  --text-h2--letter-spacing: -0.005em;
  --text-h2--font-weight: 100;

  --text-h3: 3rem; /* 48px – section headings */
  --text-h3--letter-spacing: 0;
  --text-h3--font-weight: 300;

  --text-h4: 2.125rem; /* 34px – screen titles */
  --text-h4--letter-spacing: 0.0025em;
  --text-h4--font-weight: 300;

  --text-h5: 1.5rem; /* 24px – card titles */
  --text-h5--letter-spacing: 0;
  --text-h5--font-weight: 300;

  --text-h6: 1.25rem; /* 20px – subsection titles */
  --text-h6--letter-spacing: 0.0015em;
  --text-h6--font-weight: 400;

  /* Body text */
  --text-body: 1rem; /* 16px – base body */
  --text-body--letter-spacing: 0.005em;
  --text-body--font-weight: 300;

  --text-body-small: 0.875rem; /* 14px – small body */
  --text-body-small--letter-spacing: 0.0025em;
  --text-body-small--font-weight: 300;

  /* Legacy aliases for backward compatibility */
  --text-screen-title: var(--text-h4);
  --text-section-title: var(--text-h6);
  --text-card-title: var(--text-h5);

  /* Special sizes */
  --text-avatar-initial: 2.5rem; /* 40px – avatar initial letter */
  --text-display-emoji: 4rem; /* 64px – large emoji/icon */
}

/* Override react-native-web Image inner element's background properties.
   RNW renders Image as nested divs with background-image on the inner div.
   These styles cannot be set via props — only CSS can reach the inner child. */
.rnw-image-contain-top > * {
  background-size: contain !important;
  background-position: top center !important;
}

html,
body,
#root {
  background-color: #f1f1f1;
}

.audio-player-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border: 0;
  border-radius: 9999px;
  background: #ffb104;
  cursor: pointer;
}

.audio-player-range::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border: 0;
  border-radius: 9999px;
  background: #ffb104;
  cursor: pointer;
}
